import React, { useState } from 'react';
import type { Props } from './AdminBar';
import { ActivatorButton, LoadingButton } from './common';
import { isEventsPanelOpen } from './adminEventsPanelStorage';

const AdminBar = React.lazy(
  () => import(/* webpackChunkName: "admin-bar" */ './AdminBar'),
);

const BucketingOnlyBar = React.lazy(
  () =>
    import(/* webpackChunkName: "bucketing-only-bar" */ './BucketingOnlyBar'),
);

type ActivatorProps = Props & {
  bucketingOnly?: boolean;
};

const AdminBarActivator: React.FC<ActivatorProps> = (props) => {
  const [isActivated, setIsActivated] = useState(() => {
    if (isEventsPanelOpen()) return true;
    return props.openByDefault;
  });

  if (!props.admin && !props.bucketingOnly) {
    return null;
  }

  if (isActivated) {
    return (
      <React.Suspense fallback={<LoadingButton />}>
        {props.bucketingOnly ? (
          <BucketingOnlyBar />
        ) : (
          <AdminBar {...props} openByDefault={true} />
        )}
      </React.Suspense>
    );
  }

  return <ActivatorButton onClick={() => setIsActivated(true)} />;
};

export default AdminBarActivator;
